export default {
    "hd": "Hoạt động",
    "nhd": "Ngừng hoạt động",
}
